export const TEMPLATE_FILENAME = 'upload-template.csv';
export const TEMPLATE_CONTENTS = 'locationName,address,city,postalCode,country,lat,long\n,,,,,,';
